import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import StorageIcon from '@material-ui/icons/Storage';
import { ImagesPage } from './ImagesPage';

// routeRef explícito é obrigatório para aparecer no menu lateral (ver o
// comentário em ../users/index.tsx). A visibilidade para quem não é admin é decidida
// lá (FilteredNavContent), com a mesma permissão da página Pipelines.
export const imagesRouteRef = createRouteRef();

const imagesPage = PageBlueprint.make({
  name: 'images',
  params: {
    path: '/images',
    title: 'Imagens',
    icon: <StorageIcon />,
    routeRef: imagesRouteRef,
    loader: async () => <ImagesPage />,
  },
});

export const imagesModule = createFrontendModule({
  pluginId: 'app',
  extensions: [imagesPage],
});
